import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AgreementCreationResult} from './api.service';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {SessionsService} from '../sessions.service';

@Injectable({
  providedIn: 'root'
})
export class PaypalApiService {

  API_URL = (environment.production) ? /*"https://assetlicences.herokuapp.com"*/"https://database.assetx.it:3443":
    "http://localhost:8081";

  constructor(
    private router: Router,
    private http: HttpClient,
    private session: SessionsService
  ) { }

  public createAgreement(email: string, softwareName: string): Observable<AgreementCreationResult> {
    return <Observable<AgreementCreationResult>>this.http.post<AgreementCreationResult>(this.API_URL +
      '/subscriptions/createSubscription',
      {
        email: email,
        software_name: softwareName
      });
  }
}
